import React from 'react';
import { FieldRenderProps } from 'react-final-form';
import { Form, FormFieldProps, Label } from 'semantic-ui-react';

interface IProps
  extends FieldRenderProps<number, HTMLElement>,
    FormFieldProps {}

const NumberInput: React.FC<IProps> = ({
  label,
  input,
  width,
  placeholder,
  disabled,
  readOnly,
  inputOnChange,
  meta: { touched, error },
}) => {
  return (
    <Form.Field error={touched && !!error} width={width}>
      {label && <label>{label}</label>}
      <input
        type='number'
        min='0'
        {...input}
        placeholder={placeholder}
        disabled={disabled}
        readOnly={readOnly}
        onChange={(e) => {
          input.onChange(e);
          inputOnChange && inputOnChange(e);
        }}
      />
      {touched && error && (
        <Label basic color='red'>
          {error}
        </Label>
      )}
    </Form.Field>
  );
};

export default NumberInput;
